import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import * as React from 'react';

const SvgClose = ({
  accessibilityText,
  forwardedRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  width: 16,
  height: 16,
  "aria-hidden": accessibilityText ? undefined : true,
  "aria-label": accessibilityText,
  fill: "currentColor",
  focusable: false,
  ref: forwardedRef,
  role: accessibilityText ? 'img' : undefined
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M12.95 11.536 9.414 8l3.536-3.536-1.414-1.414L8 6.586 4.464 3.05 3.05 4.464 6.586 8 3.05 11.536l1.414 1.414L8 9.414l3.536 3.536z"
}));

export default SvgClose;